export default "__VITE_ASSET__CgaF4Sij__"